import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

const ICONES = {
  good: <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 shrink-0 mt-0.5" />,
  warn: <AlertTriangle className="w-3.5 h-3.5 text-amber-400 shrink-0 mt-0.5" />,
  bad: <XCircle className="w-3.5 h-3.5 text-red-400 shrink-0 mt-0.5" />,
};

const couleurScore = (s) => (s >= 75 ? 'text-emerald-400' : s >= 50 ? 'text-amber-400' : 'text-red-400');
const fmtPct = (v) => `${v > 0 ? '+' : ''}${v} %`;

/** Jauge de score + effets chiffrés + conseils pédagogiques (live sur le brouillon). */
export const ScoreMerch = ({ titre, fx, effets, testPrefix }) => {
  const score = fx.score ?? 0;
  return (
    <div className="surface-card p-4 space-y-3" data-testid={`${testPrefix}-score`}>
      <div className="flex items-end justify-between gap-3">
        <div>
          <p className="overline">{titre}</p>
          <p className={`font-display text-4xl font-black leading-none mt-1 ${couleurScore(score)}`} data-testid={`${testPrefix}-score-value`}>{score}<span className="text-base text-slate-500">/100</span></p>
        </div>
        <div className="flex-1 h-2 rounded-full bg-ink-800 overflow-hidden">
          <div className={`h-full transition-[width] duration-500 ${score >= 75 ? 'bg-emerald-500' : score >= 50 ? 'bg-amber-500' : 'bg-red-500'}`} style={{ width: `${score}%` }} />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {effets.map(e => (
          <div key={e.label} className="rounded border border-ink-700 bg-ink-900/40 px-2 py-1.5" data-testid={`${testPrefix}-effet-${e.key}`}>
            <p className="text-[9px] uppercase tracking-wider text-slate-500">{e.label}</p>
            <p className={`font-mono text-sm font-bold ${e.value > 0 ? 'text-emerald-400' : e.value < 0 ? 'text-red-400' : 'text-slate-300'}`}>{fmtPct(e.value)}</p>
          </div>
        ))}
      </div>
      <ul className="space-y-1.5" data-testid={`${testPrefix}-conseils`}>
        {fx.conseils.length === 0 && <li className="text-[11px] text-slate-500">Placez vos familles pour obtenir un diagnostic.</li>}
        {fx.conseils.map((c, i) => (
          <li key={i} className="flex items-start gap-2 text-[11px] text-slate-300 leading-snug">{ICONES[c.tone]}<span>{c.texte}</span></li>
        ))}
      </ul>
    </div>
  );
};
